// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"bc91e53a","192":"bc91e53a","263":"74fadf77","563":"26c67e95","861":"7baf170a"}[chunkId] + ".chunk.css";
};